module.exports = __webpack_public_path__ + "8ff3611d2178f66bd8273b959f700a76.jpg";